/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Source_ContextInputs */

const en_gc_guides_source_context = /** @type {(inputs: Gc_Guides_Source_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature details refer to the linked version. Follow the upstream release notes when using a different build.`)
};

const zh_gc_guides_source_context = /** @type {(inputs: Gc_Guides_Source_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能说明以链接中的版本为准；使用其他构建时，请同时查看对应发布说明。`)
};

/**
* | output |
* | --- |
* | "Feature details refer to the linked version. Follow the upstream release notes when using a different build." |
*
* @param {Gc_Guides_Source_ContextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_source_context = /** @type {((inputs?: Gc_Guides_Source_ContextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Source_ContextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_source_context(inputs)
	return zh_gc_guides_source_context(inputs)
});
export { gc_guides_source_context as "gc.guides.source_context" }